import axios from "axios";
// import bugsnagClient from "../utils/bugsnag";

const getAuthToken = () => "BEARER " + window.localStorage.getItem("token");

const client = axios.create({
	baseURL: process.env.VUE_APP_SERVICES,
	timeout: 40000
});

if (window.localStorage) {
	client.interceptors.request.use((config) => {
		if (window.localStorage.getItem("token")) {
			config.headers.Authorization = getAuthToken();
			// testing for IE10 or 11 to add a random string to help with a known IE cache bug
			// https://forum.vuejs.org/t/vue-js-in-ie-11-reactivity-issue-array-doesnt-update/10177
			if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
				config.params = {
					rand: new Date().getTime()
				};
			}
		}
		return config;
	});
}

// interceptor to catch errors
const errorInterceptor = (error) => {
	let message = "";
	// capture all the error responses
	switch (error.response.status) {
		case 400:
			message = `400 ERROR: ${error.response.data.error}`;
			break;
		case 401: // authentication error, logout the user
			message = `Please login again, Session Expired`;
			break;
		default:
			message = `${error.response.status}, ${error.message}`;
	}
	// if we have a messages and bugsnag we'll throw a bugsnag handled error
	// if (bugsnagClient) {
	// 	const y = new Error(message);
	// 	bugsnagClient.notify(y);
	// } else {
	// 	// If no bugsnag we'll just pass through to the console
	// 	console.error(message);
	// }
	return Promise.reject(error);
};

// Interceptor for responses
const responseInterceptor = (response) => {
	switch (response.status) {
		case 200:
			// yay!
			break;
		// any other cases
		default:
		// default case
	}

	return response;
};

client.interceptors.response.use(responseInterceptor, errorInterceptor);

export default client;
